import { createFileRoute, redirect } from "@tanstack/react-router";

/** Folded into the editor's Activity and Composition panels, selecting the same activity. */
export const Route = createFileRoute("/console/spaces_/$joinCode/activities/$addedActivity")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/console/spaces/$joinCode/control",
      params: { joinCode: params.joinCode },
      search: { panel: "activity", select: params.addedActivity },
    });
  },
});
